module.exports = __webpack_public_path__ + "static/img/feature03.ae91d66d.png";